import { Component } from '@angular/core';
import { MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { TablerIconsModule } from 'angular-tabler-icons';

@Component({
  selector: 'app-score-report',
  templateUrl: './score-report.component.html',
  styleUrls: ['./score-report.component.scss'],
  standalone: true,
  imports: [ TablerIconsModule, MatDialogModule ]
})
export class ScoreReportComponent {
  constructor(
    public dialogRef: MatDialogRef<ScoreReportComponent>,
  ) {}  

  close(){
    this.dialogRef.close();
  }
}
